import axios from 'axios'

export const oauthAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_OAUTH_API_URL,
  withCredentials: true,
  timeout: 15000
})

oauthAxiosInstance.interceptors.request.use(config => {
  const protocol = config.baseURL && new URL(config.baseURL).protocol
  if (!(protocol === 'https:' || (process.env.NODE_ENV !== 'production' && protocol === 'http:')))
    throw new Error('OAuth API URL is not configured')
  return config
})
